import { render, staticRenderFns } from "./MaiaChat.vue?vue&type=template&id=16797d8e&scoped=true"
import script from "@/components/MaiaChat/MaiaChat.ts?vue&type=script&lang=ts&external"
export * from "@/components/MaiaChat/MaiaChat.ts?vue&type=script&lang=ts&external"
import style0 from "@/components/MaiaChat/maia-chat.scss?vue&type=style&index=0&id=16797d8e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16797d8e",
  null
  
)

export default component.exports